// extracted by mini-css-extract-plugin
export default {"fileWrapper":"ProductionCoverSidebar_fileWrapper__oteOa"};